import Icon from "Trackalyze/Icon";
import React from "react";
import Typo from "./Typo";
import Badge from "./Badge";

const Button = React.forwardRef(({
  pure,
  filled,
  tonal,
  outline,
  text,
  elevated,
  toggle,
  selected,
  active,
  size,
  semi,
  disabled,
  error,
  icon,
  fab,
  small,
  stacked,
  elevation,
  className,
  variant,
  style,
  onMouseEnter,
  onMouseLeave,
  onFocus,
  onBlur,
  onClick,
  symbol,
  iconProps,
  trailing,
  badge,
  badgeProps,
  children,
  ...rest
}, ref) => {
  const derivedVariant =
    variant ||
    (filled ? "filled" : "") ||
    (tonal ? "tonal" : "") ||
    (outline ? "outline" : "") ||
    (text ? "text" : "") ||
    (elevated ? "elevated" : "") ||
    undefined;

  const classes = [
    !pure && "ta-button",
    small && "ta-height_auto",
    elevation &&
      (typeof elevation === "number" || typeof elevation === "string"
        ? "ta-elevation_shadow-" + elevation
        : "ta-elevation_shadow-1"),
    className,
  ]
    .filter(Boolean)
    .join(" ");

  const action = (e) => {
    onClick({
      clientWidth: e.currentTarget.clientWidth,
      clientHeight: e.currentTarget.clientHeight,
      offsetLeft: e.currentTarget.offsetLeft,
      offsetTop: e.currentTarget.offsetTop,
      clientX: e.nativeEvent.clientX,
      clientY: e.nativeEvent.clientY,
      offsetX: e.nativeEvent.offsetX,
      offsetY: e.nativeEvent.offsetY,
      stopPropagation: () => e.stopPropagation(),
      preventDefault: () => e.preventDefault(),
    });
  };

  return pure ? (
    <button
      ref={ref}
      className={classes}
      onClick={onClick && action}
      disabled={disabled}
      style={style}
      {...rest}
    >
      {children}
    </button>
  ) : (
    <button
      ref={ref}
      data-variant={derivedVariant}
      data-selected={selected || undefined}
      data-active={active || undefined}
      data-toggle={toggle || undefined}
      data-size={size || undefined}
      data-semi={semi || undefined}
      data-icon={icon || undefined}
      data-fab={fab || undefined}
      data-error={error || undefined}
      data-stacked={stacked || undefined}
      onClick={onClick && action}
      className={classes}
      style={style}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      onFocus={onFocus}
      onBlur={onBlur}
      disabled={disabled}
      {...rest}
    >
      {icon ? (
        <Icon symbol={symbol} size={small ? "s" : ""} {...iconProps} />
      ) : (
        <>
          {symbol && (
            <Icon symbol={symbol} {...iconProps} className={"ta-button_icon"} />
          )}
          {children && <label className="ta-button_label">{children}</label>}
        </>
      )}
      {trailing && (
        <Icon
          symbol={trailing}
          className={"ta-button_icon ta-button_icon--trailing"}
        />
      )}
      {badge && badgeProps && badgeProps.small ? (
        <Typo
          type="label"
          size="s"
          className="ta-is-absolute ta-is-topright ta-margin_right-xxxs ta-margin_top-xxxs"
        >
          <Badge {...badgeProps} />
        </Typo>
      ) : (
        badge && <Badge {...badgeProps}>{badge}</Badge>
      )}
    </button>
  );
});

export default Button;
